export default "__VITE_ASSET__BZBHGRa9__"